/*
 Copyright (c) 2017 Wells Fargo. 455 Market St., San Francisco, CA 94105 All rights reserved.

 This software is the confidential and proprietary information of Wells Fargo
 bank. ('Confidential Information'). You shall not disclose such Confidential
 Information and shall use it only in accordance with the terms of the license
 agreement you entered into with WellsFargo.

 Author: Akhil Mara

 Description:
 */
import React from 'react';
import { connect } from 'react-redux';
import { compose } from 'recompose';
import { getClasses } from 'wfui-digital-core/es/lib';
import withBrand from 'wfui-digital-core/es/withBrand';
import withFonts from 'wfui-digital-core/es/withFonts';
import AccessibleClick from 'wfui-digital-core/es/AccessibleClick';
import SearchIcon from '../../../icons/search-icon/SearchIcon';
import withSettings from '../../../with-settings/with-settings';
import { openGlobalSearch as _openGlobalSearch } from '../../../../lib/store/global-search/actions';
import { closeNavigationMenu as _closeNavigationMenu } from '../../../../lib/store/navigation-menu/actions';
import styles from './NavigationMenuItem.less';

var NavigationMenuSearchItem = function NavigationMenuSearchItem(_ref) {
  var item = _ref.item,
      brand = _ref.brand,
      useWFFonts = _ref.useWFFonts,
      openGlobalSearch = _ref.openGlobalSearch,
      closeNavigationMenu = _ref.closeNavigationMenu,
      settings = _ref.settings;

  var openSearch = function openSearch() {
    closeNavigationMenu();
    openGlobalSearch();
  };

  var classes = ['item', 'home', useWFFonts && 'useWFFonts'];
  var classNames = getClasses({
    styles: styles,
    classes: classes,
    brand: brand
  });
  var globalSearchEnabled = settings.globalSearchEnabled;
  return globalSearchEnabled ? /*#__PURE__*/React.createElement("li", {
    className: classNames
  }, /*#__PURE__*/React.createElement(AccessibleClick, null, /*#__PURE__*/React.createElement("a", {
    role: "button",
    tabIndex: "0",
    onAccessibleClick: openSearch
  }, /*#__PURE__*/React.createElement(SearchIcon, {
    transform: true
  }), /*#__PURE__*/React.createElement("span", null, item.linkName)))) : null;
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    openGlobalSearch: function openGlobalSearch() {
      return dispatch(_openGlobalSearch());
    },
    closeNavigationMenu: function closeNavigationMenu() {
      return dispatch(_closeNavigationMenu());
    }
  };
};

export default compose(withBrand, withFonts, withSettings, connect(null, mapDispatchToProps))(NavigationMenuSearchItem);